// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalEligibilityResultSearchBase } from './medicalEligibilityResultSearchBase.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalEligibilityResultSearchResponse {
    'results': Array<MedicalEligibilityResultSearchBase>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalEligibilityResultSearchResponse>> = [
        {
            "name":     "results",
            "baseName": "results",
            "type":     "Array<MedicalEligibilityResultSearchBase>"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalEligibilityResultSearchResponse.attributeTypeMap;
    }
}
